/**
 * @name v0.0.7版本过渡
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2010-1-1
 * 
*/
// 导入v0.0.6数据格式
import * as v006 from './v006.js';

export const upgrade = function ( formData ) {
    // 取出当前版本
    let { version } = formData;
    /** 
     * 如果当前版本为v0.0.7,则该数据不需要更新直接抛出,
     * 否则先将数据格式化为v0.0.6数据在进行处理
     *
    **/
    if ( version == '0.0.7') return formData;
    // 深拷贝v006数据
    let currentData = v006.upgrade(formData);
    // 添加变量字典字段
    currentData.variableMap = {}

    // 版本号更新
    currentData.version = '0.0.7';
    return currentData;
}



// WEBPACK FOOTER //
// ./src/assets/version/v007.js